import React, { useState } from 'react';
import './AboutTOON.css';

const AboutTOON: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section
      className={`about-toon${expanded ? ' is-expanded' : ''}`}
      itemScope
      itemType="https://schema.org/DefinedTerm"
      aria-label="About TOON format"
    >
      <h2 className="about-toon__heading" itemProp="name">
        What is TOON?
      </h2>
      <p className="about-toon__definition" itemProp="description">
        <strong>TOON (Token-Oriented Object Notation)</strong> is a lightweight data format that
        eliminates JSON's redundant syntax — extra braces, brackets, and quotes — while preserving
        data structure through indentation. Converting JSON to TOON typically{' '}
        <strong>reduces token count by 30-60%</strong> when sent to LLMs like GPT-4, Claude, and
        Gemini, lowering your API costs without losing data fidelity. This converter runs entirely
        in your browser; nothing is uploaded.
      </p>
      <button
        type="button"
        className="about-toon__toggle"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        {expanded ? 'Show less' : 'Read more'}
      </button>
    </section>
  );
};

export default AboutTOON;
